import React, {createContext, useState, useEffect, ReactNode} from 'react';


// Define the context value type
interface AuthContextType {
    user: string | null;
    setUser: (tempUser: string | null) => void;
}


// Create the context with an initial value
const AuthContext = createContext<AuthContextType | undefined>(undefined);


export const useAuth = () => {
    const context = React.useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};


interface AuthProviderProps {
    children: ReactNode;
}


export const AuthProvider: React.FC<AuthProviderProps> = ({children}) => {
    const [user, setUser] = useState<string | null>(null);


    useEffect(() => {
        const tempUser = localStorage.getItem('user');

        if (tempUser) {
            setUser(tempUser);
        } else {
            setUser(null);
        }

    }, [user]);


    return (
        <AuthContext.Provider value={{user, setUser}}>
            {children}
        </AuthContext.Provider>
    );
};
